import type { NavigateToOptions } from '#app/composables/router';

export const useGoTo = () => {
  const localePath = useLocalePath();

  return (path: string, options?: NavigateToOptions): ReturnType<typeof navigateTo> => {
    return navigateTo(localePath(path), options);
  };
};
